<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Vendor Account</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>Loyalty Point System</b>
      /
      <b>Vendor Account</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
      <div class="col-12 col-lg-6 col-sm-12"></div>

      <div
        class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center"
      >
        <span class="m-auto"></span>
        <div class="btn-group" role="group">
          <button
            class="btn btn-secondary"
            id="btn-active"
            :class="{ 'change-background': allClick }"
            type="button"
            @click="clickAll()"
          >
            All
          </button>
          <button
            class="btn btn-secondary"
            id="btn-active"
            :class="{ 'change-background': activeClick }"
            type="button"
            @click="insertActive()"
          >
            Active
          </button>
          <button
            class="btn btn-secondary"
            id="btn-inactive"
            :class="{ 'change-background': inactiveClick }"
            type="button"
            @click="insertInactive()"
          >
            Inactive
          </button>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Vendor Lists</h4>
            <router-link
              :to="{ name: 'account-add' }"
              type="button"
              class="btn btn-primary btn-rounded"
              style="margin-bottom: 20px; width: 10%;"
              >Add
            </router-link>
            <div class="table-responsive">
              <!-- All -->
              <table
                v-if="allClick"
                id="vendor_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Vendor Name</th>
                    <th>Email</th>
                    <th>Username</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(vendor, index) in all" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ vendor.name }}</td>
                    <td>{{ vendor.user.email }}</td>
                    <td>{{ vendor.user.username }}</td>
                    <td>{{ checkActive(vendor.user.active) }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'account-edit',
                          params: { id: vendor.id }
                        }"
                        type="button"
                        class="btn btn-primary btn-rounded btn-block"
                        >View Details</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- Active -->
              <table
                v-if="activeClick"
                id="vendor_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Vendor Name</th>
                    <th>Email</th>
                    <th>Username</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(vendor, index) in vendors" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ vendor.name }}</td>
                    <td>{{ vendor.user.email }}</td>
                    <td>{{ vendor.user.username }}</td>
                    <td>{{ checkActive(vendor.user.active) }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'account-edit',
                          params: { id: vendor.id }
                        }"
                        type="button"
                        class="btn btn-primary btn-rounded btn-block"
                        >View Details</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- Inactive -->
              <table
                v-if="inactiveClick"
                id="inactive_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Vendor Name</th>
                    <th>Email</th>
                    <th>Username</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(vendor, index) in inactive" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ vendor.name }}</td>
                    <td>{{ vendor.user.email }}</td>
                    <td>{{ vendor.user.username }}</td>
                    <td>{{ checkActive(vendor.user.active) }}</td>
                    <td>
                      <router-link
                        :to="{
                          name: 'account-edit',
                          params: { id: vendor.id }
                        }"
                        type="button"
                        class="btn btn-primary btn-rounded btn-block"
                        >View Details</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "account-view",
  components: {},

  data() {
    return {
      all: [],
      vendors: [],
      inactive: [],
      allClick: true,
      activeClick: false,
      inactiveClick: false
    };
  },

  methods: {
    async loadEntity() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        try {
          let result = await axios.get(axios.lpsURL + "/vendor", {
            headers: {
              Authorization: "Bearer " + token
            }
          });
          this.all = result.data.vendor;
          result.data.vendor.forEach(element => {
            if (element.user.active == 1) {
              console.log(element);
              this.vendors.push(element);
            }
            if (element.user.active == 0) {
              console.log(element);
              this.inactive.push(element);
            }
          });
        } catch (error) {
          console.log(error);
        }
      }
    },

    clickAll() {
      (this.allClick = true), (this.activeClick = false);
      this.inactiveClick = false;
    },

    insertActive() {
      (this.allClick = false), (this.activeClick = true);
      this.inactiveClick = false;
    },

    insertInactive() {
      (this.allClick = false), (this.activeClick = false);
      this.inactiveClick = true;
    },

    productRequest(id) {
      return "/vendor/product/" + id;
    },

    companyRequest(id) {
      return "/vendor/company/" + id;
    },

    killDatatable() {
      $("#vendor_tbl")
        .DataTable()
        .destroy();
    },

    createDatatable() {
      $("#vendor_tbl").DataTable({
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4]
            }
          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4]
            }
          }
        ]
      });
    },

    checkActive(int) {
      switch (int) {
        case 0:
          return "Inactive";
        case 1:
          return "Active";
        default:
          return "Inactive";
      }
    }
  },

  async created() {
    await this.loadEntity();
    this.createDatatable();
  },

  mounted() {}
};
</script>

<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}
</style>
